import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("gdas_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export async function downloadAuthed(path, filename) {
  const token = localStorage.getItem("gdas_token");
  const resp = await fetch(`${API}${path}`, {
    headers: { Authorization: `Bearer ${token}` },
  });
  if (!resp.ok) throw new Error(`Download failed (${resp.status})`);
  const blob = await resp.blob();
  const url = URL.createObjectURL(blob);
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  setTimeout(() => URL.revokeObjectURL(url), 1000);
}

export async function streamAnalysis({ text, model, language, title }, { onMeta, onDelta, onDone, onError }) {
  const token = localStorage.getItem("gdas_token");
  const resp = await fetch(`${API}/analyze/stream`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
    body: JSON.stringify({ text, model, language, title }),
  });
  if (!resp.ok) {
    const err = await resp.text();
    onError && onError(err || "Request failed");
    return;
  }
  const reader = resp.body.getReader();
  const decoder = new TextDecoder("utf-8");
  let buffer = "";
  while (true) {
    const { value, done } = await reader.read();
    if (done) break;
    buffer += decoder.decode(value, { stream: true });
    let idx;
    while ((idx = buffer.indexOf("\n\n")) !== -1) {
      const chunk = buffer.slice(0, idx);
      buffer = buffer.slice(idx + 2);
      const lines = chunk.split("\n");
      let event = "message";
      let data = "";
      for (const line of lines) {
        if (line.startsWith("event:")) event = line.slice(6).trim();
        else if (line.startsWith("data:")) data += line.slice(5).trim();
      }
      if (!data) continue;
      try {
        const parsed = JSON.parse(data);
        if (event === "meta") onMeta && onMeta(parsed);
        else if (event === "delta") onDelta && onDelta(parsed.content);
        else if (event === "done") onDone && onDone(parsed);
        else if (event === "error") onError && onError(parsed.error);
      } catch (e) {
        console.warn("SSE parse error", e, data);
      }
    }
  }
}
